export default "__VITE_ASSET__DwTD4kQv__"